/* Knapkon integration: native Shopify URLs; no storage or external runtime. */
(() => {
  if (window.KnapkonTheme) return;
  const bound = new WeakSet();
  const returnFocus = new WeakMap();
  const flipbooks = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let bodyOverflow;
  function lock() {
    if (bodyOverflow === undefined) bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  function unlock() {
    if (!document.querySelector('.kp-root dialog[open]') && bodyOverflow !== undefined) {
      document.body.style.overflow = bodyOverflow;
      bodyOverflow = undefined;
    }
  }
  function close(dialog, restore = true) {
    if (!dialog?.open) return;
    const focus = returnFocus.get(dialog);
    dialog.close();
    unlock();
    if (restore && focus?.isConnected) focus.focus({ preventScroll: true });
  }
  function open(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('.kp-root dialog[open]').forEach(d => close(d, false));
    document.querySelectorAll('[data-kp-menu][open]').forEach(d => { d.open = false; });
    const menu = trigger?.closest('[data-kp-menu]');
    returnFocus.set(dialog, menu ? menu.querySelector('summary') : trigger);
    dialog.querySelectorAll('[data-kp-src]').forEach(el => {
      if (!el.getAttribute('src')) el.setAttribute('src', el.dataset.kpSrc);
    });
    dialog.showModal();
    lock();
    const book = dialog.querySelector('[data-kp-book]');
    if (book) {
      if (window.St?.PageFlip) {
        try { initFlipbook(book); } catch (error) { console.warn('Baukasten: einfache Ansicht aktiv.', error); }
      }
      showPage(book, Number(book.dataset.index || 0));
    }
    dialog.querySelector('[data-kp-close]')?.focus({ preventScroll: true });
    return true;
  }
  function showPage(book, index) {
    const enhanced = flipbooks.get(book);
    if (enhanced) {
      enhanced.resize();
      enhanced.jump(index);
      return;
    }
    const active = document.activeElement;
    const sources = [...book.querySelector('template').content.querySelectorAll('[data-url]')].map(el => el.dataset.url);
    const nextIndex = Math.max(0, Math.min(index, sources.length - 1));
    book.dataset.index = String(nextIndex);
    const img = book.querySelector('[data-kp-book-image]');
    const error = book.querySelector('.kp-book-error');
    error.hidden = true;
    const loading = book.querySelector('[data-kp-book-loading]');
    if (loading) loading.hidden = false;
    img.hidden = false;
    img.alt = `Baukasten, Seite ${nextIndex + 1}`;
    img.src = sources[nextIndex];
    book.querySelector('[data-kp-book-count]').textContent = `Seite ${nextIndex + 1} von ${sources.length}`;
    book.querySelector('[data-kp-book-prev]').disabled = nextIndex === 0;
    book.querySelector('[data-kp-book-next]').disabled = nextIndex === sources.length - 1;
    if (active === book.querySelector('[data-kp-book-next]') && active.disabled) {
      book.querySelector('[data-kp-book-prev]').focus({ preventScroll: true });
    } else if (active === book.querySelector('[data-kp-book-prev]') && active.disabled) {
      book.querySelector('[data-kp-book-next]').focus({ preventScroll: true });
    }
  }
  function moveBook(book, direction) {
    const enhanced = flipbooks.get(book);
    if (enhanced) enhanced.move(direction);
    else showPage(book, Number(book.dataset.index || 0) + direction);
  }
  function initFlipbook(book) {
    if (flipbooks.has(book)) return;
    const urls = [...book.querySelector('template').content.querySelectorAll('[data-url]')].map(el => el.dataset.url);
    if (!urls.length) return;
    const dialog = book.closest('dialog');
    const fallback = book.querySelector('.kp-book-pages');
    const stage = document.createElement('div');
    stage.className = 'kp-flip-stage';
    const position = document.createElement('div');
    position.className = 'kp-flip-position';
    const mount = document.createElement('div');
    mount.className = 'kp-flip-mount';
    mount.setAttribute('aria-label', 'Der Baukasten: blätterbarer Prospekt');
    position.append(mount); stage.append(position);
    fallback.before(stage);
    const pages = urls.map((url, index) => {
      const page = document.createElement('div');
      page.className = 'kp-flip-page';
      const img = document.createElement('img');
      img.alt = `Der Baukasten 2026, Seite ${index + 1}`;
      img.width = 1100; img.height = 1556; img.draggable = false;
      img.dataset.src = url; img.decoding = 'async';
      img.addEventListener('error', () => {
        img.hidden = true;
        const note = document.createElement('span');
        note.className = 'kp-flip-page-error';
        note.textContent = `Seite ${index + 1} konnte nicht geladen werden. Nutze „Seite groß öffnen“ oder lade die Ansicht neu.`;
        if (!page.querySelector('.kp-flip-page-error')) page.append(note);
      });
      page.append(img); mount.append(page);
      return page;
    });
    const tools = document.createElement('div');
    tools.className = 'kp-flip-tools';
    const label = document.createElement('label');
    label.textContent = 'Seite wählen ';
    const select = document.createElement('select');
    select.setAttribute('aria-label', 'Baukasten: Seite wählen');
    urls.forEach((url, index) => select.add(new Option(String(index + 1), String(index))));
    label.append(select);
    const large = document.createElement('a');
    large.textContent = 'Seite groß öffnen';
    large.target = '_blank'; large.rel = 'noopener';
    large.setAttribute('aria-label', 'Aktuelle Seite groß öffnen (neuer Tab)');
    const hint = document.createElement('p');
    hint.className = 'kp-flip-hint';
    hint.textContent = 'Seitenecke ziehen, wischen oder die Pfeile verwenden.';
    tools.append(label, large); book.append(tools, hint);
    let flip, ready = false, portrait = false;
    const preload = index => {
      for (let i = Math.max(0, index - 3); i < Math.min(urls.length, index + 6); i++) {
        const img = pages[i].querySelector('img');
        if (!img.getAttribute('src')) img.src = urls[i];
      }
    };
    const sync = () => {
      if (!ready) return;
      const index = flip.getCurrentPageIndex();
      const single = flip.getOrientation() === 'portrait' || index === 0 || index === urls.length - 1;
      book.dataset.index = String(index);
      book.querySelector('[data-kp-book-count]').textContent = single
        ? `Seite ${index + 1} von ${urls.length}`
        : `Seiten ${index + 1}–${Math.min(index + 2, urls.length)} von ${urls.length}`;
      const prev = book.querySelector('[data-kp-book-prev]');
      const next = book.querySelector('[data-kp-book-next]');
      prev.disabled = index === 0; next.disabled = index >= urls.length - 1;
      if (document.activeElement === prev && prev.disabled) next.focus({preventScroll:true});
      if (document.activeElement === next && next.disabled) prev.focus({preventScroll:true});
      select.value = String(index); large.href = urls[index];
      position.classList.toggle('kp-flip-cover', !portrait && index === 0);
      position.classList.toggle('kp-flip-back', !portrait && index === urls.length - 1);
      preload(index);
    };
    const resize = () => {
      if (!dialog.open) return;
      portrait = stage.clientWidth < 620;
      const width = Math.max(90, Math.floor(Math.min((stage.clientWidth - 12) / (portrait ? 1 : 2), (stage.clientHeight - 12) * 210 / 297, 620)));
      const height = Math.round(width * 297 / 210);
      position.style.width = mount.style.width = `${width * (portrait ? 1 : 2)}px`;
      position.style.height = mount.style.height = `${height}px`;
      if (ready) {
        flip.getSettings().minWidth = portrait ? width : Math.min(width, 140);
        flip.update(); sync();
      }
      return width;
    };
    dialog.classList.add('kp-flip-dialog');
    const width = resize();
    try {
      flip = new window.St.PageFlip(mount, {
        width: 595, height: 842, size: 'stretch',
        minWidth: portrait ? width : 140, maxWidth: 620,
        minHeight: 100, maxHeight: 1000, autoSize: false,
        showCover: true, usePortrait: true, mobileScrollSupport: true,
        flippingTime: reducedMotion.matches ? 1 : 850,
        maxShadowOpacity: .28, showPageCorners: !reducedMotion.matches,
        swipeDistance: 25
      });
      const api = {
        resize,
        jump(index) {
          const target = Math.max(0, Math.min(urls.length - 1, index));
          flip.getRender().finishAnimation();
          preload(target); flip.turnToPage(target); sync();
        },
        move(direction) {
          if (flip.getState() !== 'read') return;
          const index = flip.getCurrentPageIndex();
          if ((direction < 0 && index === 0) || (direction > 0 && index >= urls.length - 1)) return;
          preload(index + direction * 2);
          if (reducedMotion.matches) {
            if (direction > 0) flip.turnToNextPage(); else flip.turnToPrevPage();
            sync();
          } else if (direction > 0) flip.flipNext('bottom'); else flip.flipPrev('bottom');
        }
      };
      flip.on('init', () => { ready = true; resize(); sync(); });
      flip.on('flip', sync);
      flip.on('changeOrientation', sync);
      flip.on('changeState', event => { book.dataset.flipState = event.data; });
      preload(0);
      flip.loadFromHTML(pages);
      flipbooks.set(book, api);
      fallback.hidden = true;
      book.querySelector('.kp-book-error').hidden = true;
      select.addEventListener('change', () => api.jump(Number(select.value)));
      window.addEventListener('resize', resize);
      dialog.addEventListener('close', () => flip.getRender().finishAnimation());
      book._kpFlipCleanup = () => {
        window.removeEventListener('resize', resize);
        flip.destroy(); flipbooks.delete(book);
      };
    } catch (error) {
      stage.remove(); tools.remove(); hint.remove();
      dialog.classList.remove('kp-flip-dialog');
      throw error;
    }
  }
  function bind(root = document) {
    root.querySelectorAll('.kp-root dialog').forEach(dialog => {
      if (bound.has(dialog)) return;
      bound.add(dialog);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); });
      dialog.addEventListener('close', unlock);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog);
      });
      dialog.addEventListener('keydown', event => {
        // Native dialog provides trapping; explicitly preserve wrap-around in older engines.
        if (event.key === 'Tab') {
          const items = [...dialog.querySelectorAll('a[href],button:not([disabled]),input,select,summary,iframe,[tabindex="0"]')]
            .filter(el => el.getClientRects().length && !el.closest('[hidden]'));
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
        const book = dialog.querySelector('[data-kp-book]');
        if (book && ['ArrowLeft','ArrowRight'].includes(event.key) && !event.target.matches('input,textarea,select')) {
          event.preventDefault();
          moveBook(book, event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      const img = dialog.querySelector('[data-kp-book-image]');
      img?.addEventListener('error', () => {
        img.hidden = true;
        dialog.querySelector('.kp-book-error').hidden = false;
        const loading = dialog.querySelector('[data-kp-book-loading]');
        if (loading) loading.hidden = true;
      });
      img?.addEventListener('load', () => {
        const loading = dialog.querySelector('[data-kp-book-loading]');
        if (loading) loading.hidden = true;
      });
    });
    root.querySelectorAll('[data-kp-menu]').forEach(menu => {
      if (bound.has(menu)) return;
      bound.add(menu);
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('[data-kp-menu][open]').forEach(other => {
          if (other !== menu) other.open = false;
        });
      });
    });
  }
  document.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-kp-close]');
    if (closeButton) { close(closeButton.closest('dialog')); return; }
    const menuTrigger = event.target.closest('[data-kp-mobile]');
    if (menuTrigger) {
      if (open(menuTrigger.closest('.kp-root').querySelector('[data-kp-mobile-dialog]'), menuTrigger)) event.preventDefault();
      return;
    }
    const trigger = event.target.closest('[data-kp-dialog]');
    if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      const dialog = [...document.querySelectorAll('[data-kp-key]')].find(d => d.dataset.kpKey === trigger.dataset.kpDialog);
      if (open(dialog, trigger)) {
        event.preventDefault();
        // Mobile links are inside a now closed dialog: restore to menu button, not an invisible link.
        if (trigger.closest('[data-kp-mobile-dialog]')) returnFocus.set(dialog, document.querySelector('[data-kp-mobile]'));
      }
      return;
    }
    const control = event.target.closest('[data-kp-book-prev],[data-kp-book-next],[data-kp-book-retry]');
    if (control) {
      const book = control.closest('[data-kp-book]');
      if (control.hasAttribute('data-kp-book-prev')) moveBook(book, -1);
      else if (control.hasAttribute('data-kp-book-next')) moveBook(book, 1);
      else showPage(book, Number(book.dataset.index || 0));
      return;
    }
    if (!event.target.closest('header')) document.querySelectorAll('[data-kp-menu][open]').forEach(m => { m.open = false; });
    const mobileLink = event.target.closest('[data-kp-mobile-dialog] a[href]');
    if (mobileLink) close(mobileLink.closest('dialog'), false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || document.querySelector('.kp-root dialog[open]')) return;
    document.querySelectorAll('[data-kp-menu][open]').forEach(m => {
      m.open = false; m.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog[open]').forEach(d => close(d, false));
    event.target.querySelectorAll('[data-kp-book]').forEach(book => book._kpFlipCleanup?.());
    unlock();
  });
  document.addEventListener('shopify:block:select', event => {
    const dialog = event.target.closest('dialog');
    if (dialog) open(dialog, null);
  });
  window.KnapkonTheme = { bind };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
})();
